import { Component, TemplateRef, ViewChild, ChangeDetectorRef, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../service/login/login.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable, BehaviorSubject, debounceTime, startWith, switchMap, tap, merge, distinctUntilChanged } from 'rxjs';
import { PlanProtectionService } from '../../service/plan-protection/plan-protection.service';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { PlanProtectionDialogComponent } from '../../dialogs/plan-protection-dialog/plan-protection-dialog.component';
import { NuevoPlanProtectionDialogComponent } from '../../dialogs/nuevo-plan-protection-dialog/nuevo-plan-protection-dialog.component';
import { SpinnerService } from '../../service/spinner-service/spinner.service';
import { VisualizadorPlanProtectionDialogComponent } from '../../dialogs/visualizador-plan-protecion/visualizador-plan-protection-dialog.component';

@Component({
  selector: 'app-garantia-pp',
  templateUrl: './garantia-pp.html',
  styleUrls: ['./garantia-pp.scss']
})

export class GarantiaPPComponent { 

  servicios = [
    {
      nombre: 'Garantias',
      disponible: '4',
      total: '4'
    },
  ]

  errorsModel = {
    placas: false,
    img_placas: false,
    noSerie: false,
    img_noSerie: false

  }

  base64NoSerie: any
  base64Placas: any
  planProtectionForm: FormGroup

  constructor(private ppService: PlanProtectionService, private fb: FormBuilder, private cdr: ChangeDetectorRef, private spinnerService: SpinnerService){
    
   
  }

  
}
